// extracted by mini-css-extract-plugin
module.exports = {"cartServiceBox":"style_cartServiceBox__3K6Ug","flexBox":"style_flexBox__3hXP_","iconBox":"style_iconBox__1JlGn","titleBox":"style_titleBox__1guoI","textBox":"style_textBox__3mLi2"};